import {createRouter, createWebHistory} from 'vue-router'
import store from "@/store";

let prefix = "/EN"
const routes = [
	{path: prefix + '/text', component: () => import('@/views/text')},
	{path: prefix + '/', component: () => import('@/views/Diverter/Home')},
	{path: prefix + '/aboutUs', component: () => import('@/views/Diverter/AboutUs/AboutUs')},
	{path: prefix + '/ListHonor', component: () => import('@/views/Diverter/AboutUs/ListHonor')},
	{path: prefix + '/Culture', component: () => import('@/views/Diverter/AboutUs/Culture')},

	{path: prefix + '/Products', component: () => import('@/views/Diverter/Products/Products')},
	{path: prefix + '/ShowProduct', component: () => import('@/views/Diverter/Products/ShowProduct')},

	{path: prefix + '/ContactUs', component: () => import('@/views/Diverter/JoinUs/ContactUs')},
	{path: '/:catchAll(.*)', name: 'not-found', component: () => import('@/views/Diverter/404'),}
]

const router = createRouter({
	history: createWebHistory(),
	routes
})

export default router
